module.exports = __webpack_public_path__ + "img/ar_select_s.6eaf6cc2.svg";